export const ACCOUNT_MANAGER = 2;

export const CAMPAIGN_CREATOR = 3;

export const BP_CONSOLE = 7;
